export class Projecttemplate {
   
    title: string;
    templatedescription: string;
    templateId: string;
    projectId: string;
    templatestate: string;
    created: Date;
    creator: string;
    recipe: string;
    organizationId: string;


}